import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "generateBtn", "btnText"]
  static values = { url: String, businessName: String }

  async generate() {
    // Confirm if there's existing content
    if (this.textareaTarget.value.trim() && !confirm("This will replace your current agreement text. Continue?")) {
      return
    }

    // Show loading state
    this.generateBtnTarget.disabled = true
    this.btnTextTarget.textContent = "Generating..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (!response.ok) {
        throw new Error("Failed to generate agreement")
      }

      const data = await response.json()
      this.textareaTarget.value = data.agreement_text

      // Flash the textarea to show it was updated
      this.textareaTarget.classList.add("ring-2", "ring-green-500")
      setTimeout(() => {
        this.textareaTarget.classList.remove("ring-2", "ring-green-500")
      }, 1500)

    } catch (error) {
      if (window.showToast) {
        window.showToast("Failed to generate agreement. Please try again.", 'error')
      } else {
        alert("Failed to generate agreement. Please try again.")
      }
    } finally {
      // Reset button state
      this.generateBtnTarget.disabled = false
      this.btnTextTarget.textContent = "Generate with AI"
    }
  }
}
